import { baseGeospatial } from "../../../../api/base/baseUrl";

const BASE_URL = "/api/v1/geography-catalog/countries";

export async function getCountryListRequest() {
  const response = await baseGeospatial.get(`${BASE_URL}/get-all-list`);
  return response.data;
}

export async function getCountryByIdRequest(id) {
  const response = await baseGeospatial.get(`${BASE_URL}/get-by-id/${id}`);
  return response.data;
}

export async function createCountryRequest(payload) {
  const response = await baseGeospatial.post(BASE_URL, payload);
  return response.data;
}

export async function updateCountryRequest(payload) {
  const response = await baseGeospatial.put(`${BASE_URL}/update`, payload);
  return response.data;
}
